import { NavItemEnum } from 'pricing-pages-ui/constants/routing/NavItems';
import { prefetchPage } from 'pricing-pages-ui/routes/loadablePages';
export function prefetchCurrentRouteChunk() {
  const slug = window.location.pathname.split('/').find(part => part && Object.values(NavItemEnum).includes(part));
  if (slug) {
    prefetchPage(slug);
  }
}